import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StatusBar = styled("div")(({ theme }) => ({
  background: theme.colors["neutral.400"],
  borderRadius: '.2rem',
  width: '100%',
  height: '.6rem',
  display: 'flex',
  justifyContent: 'end',
  overflow: 'hidden'
}));

export const AvailableBar = styled("div")(({ theme }) => ({
  background: theme.colors["neutral.400"],
  height: '.6rem',
}));
export const AcceptedBar = styled("div")(({ theme }) => ({
  background: theme.colors["blue.500"],
  height: '.6rem',
}));
export const ConfirmedBar = styled("div")(({ theme }) => ({
  background: theme.colors["green.500"],
  height: '.6rem',
}));
export const DeclinedBar = styled("div")(({ theme }) => ({
  background: theme.colors["red.500"],
  height: '.6rem',
}));

export const TicketTooltipGrid = styled("div")(({ theme }) => ({
  display: 'grid',
  padding: '1rem .7rem',
  gridTemplateColumns: 'min-content min-content 1fr',
  gap: '6px'
}));

export const TooltipTicketCount = styled(Typography)(({ theme }) => ({
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes.lg,
  fontStyle: "normal",
  fontWeight: theme.fontWeights.bold,
  lineHeight: theme.lineHeights.slim,
  color: theme.colors["neutral.950"],
  textAlign: 'center'
}));

export const TooltipTicketLabel = styled(Typography)(({ theme }) => ({
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes.md,
  fontStyle: "normal",
  fontWeight: theme.fontWeights.regular,
  lineHeight: theme.lineHeights.slim,
  color: theme.colors["neutral.800"]
}));